import React, { useContext } from 'react'
import { string } from 'prop-types'
import { BrowserRouter, Routes } from 'react-router-dom'
import { useTreatments, SplitContext } from '@splitsoftware/splitio-react'
import { RoutesNavigate, URLS } from '~components/RoutesNavigate'
import { SplitIOTreatments } from '~/constants/split-io'
import { PageLoading } from '~components/PageLoading/PageLoading'
import { Pages } from '~pages/index'

export const AppRouter = props => {
  const { isReady } = useContext(SplitContext)

  const treatments = useTreatments([SplitIOTreatments.isSelectClaimEnabled])
  const { treatment } = treatments[SplitIOTreatments.isSelectClaimEnabled]

  if (!isReady) return <PageLoading />

  return (
    <BrowserRouter>
      <Routes basename={URLS.BASE_URL}>
        <RoutesNavigate path="*">
          <Pages {...props} isSelectClaimEnabled={treatment === 'on'} />
        </RoutesNavigate>
      </Routes>
    </BrowserRouter>
  )
}

AppRouter.propTypes = {
  appUrl: string,
  portalUrl: string,
}
